var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.role == 2 || _vm.role == 4)?_c('FormulirDetail'):_vm._e(),(_vm.role == 3)?_c('StrukDetail'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }